/**
* card grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the card grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'card-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      const boxes = gsap.utils.toArray( '.card-grid__card-col' );

      boxes.forEach( ( box, i ) => {
        const anim = gsap.fromTo( box, {
          autoAlpha: 0,
          y: -50,
        }, {
          duration: 0.75,
          autoAlpha: 1,
          y: 0,
          delay: 0.2 + ( 0.2 * i ),
        } );
        ScrollTrigger.create( {
          trigger: box,
          animation: anim,
          toggleActions: 'play none none none',
          once: true,
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-grid', COMPONENT );
} )( app );
